import { IGetUniqueData } from "interfaces/FilterProps";
import { client } from "./api";
import { IMaintenance, IMaintenanceEditProps, IMaintenanceRegisterProps } from "interfaces/Maintenance";

export async function getMaintenance(
  id: string
): Promise<IGetUniqueData<IMaintenance>> {
  const api = client();
  const response = await api.get<IGetUniqueData<IMaintenance>>(`maintenance/one`, {
    params: {
      where: { id },
      relations: { superficialVehicle: { superficialClient: {client:true}} },
    },
  });
  return response.data;
}

export async function createMaintenanceService({
  maintenance,
}: IMaintenanceRegisterProps) {
  const api = client();
  const response = await api.post("maintenance", maintenance);
  return response.data;
}

export async function editMaintenanceService({
  maintenance,
}: IMaintenanceEditProps) {
  const api = client();
  delete maintenance.protocol
  const response = await api.patch("maintenance", maintenance);

  return response.data;
}

export async function activeMaintenance(id: string) {
  const api = client();
  const response = await api.post(`maintenance/${id}`);
  return response.data;
}

export async function deleteMaintenance(id: string) {
  const api = client();
  console.log('here')
  const response = await api.delete(`maintenance/${id}`);
  return response.data;
}
